var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.579,
    height: 13.121,
    viewBox: "0 0 14.579 13.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "print_FILL0_wght400_GRAD0_opsz48_1_",
    "data-name": "print_FILL0_wght400_GRAD0_opsz48 (1)",
    d: "M14.534,9.5V7.093H8.046V9.5H6.952V6h8.675V9.5Zm-9.44,1.093h0ZM16.01,12.324a.561.561,0,1,0-.383-.164A.525.525,0,0,0,16.01,12.324Zm-1.476,5.7v-3.5H8.046v3.5Zm1.093,1.093H6.952V15.914H4V11.431A1.9,1.9,0,0,1,5.932,9.5H16.648a1.9,1.9,0,0,1,1.932,1.932v4.483H15.627Zm1.859-4.3v-3.39a.811.811,0,0,0-.838-.838H5.932a.811.811,0,0,0-.838.838v3.39H6.952V13.435h8.675v1.385Z",
    transform: "translate(-4 -6)",
    fill: "#98a1a9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.984c5807b327c78a8e01204efc1e92ca.svg";
export { ForwardRef as ReactComponent };